import { createSelector } from '@ngrx/store';
import { listsFeature } from '@access-request-unicorn/state/lists/lists.reducer';
import { List } from 'types-unicorn';

export const selectList = (uniqueKey: string) => createSelector(
  listsFeature.selectLists,
  lists => lists[uniqueKey] ?? List.empty()
);
